import React from 'react';
import { BlogPost } from '../../data/blog/types';
import { getBlogImageMeta } from '../../data/blog/imageMeta';

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  const formattedDate = new Date(post.publishDate + 'T00:00:00').toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const coverMeta = getBlogImageMeta(post.coverImage);

  return (
    <a href={`/blog/${post.slug}`} className="group block">
      {/* Cover image */}
      {post.coverImage && (
        <div className="aspect-video overflow-hidden rounded-3xl bg-ink/5 mb-5">
          <img
            src={post.coverImage}
            srcSet={coverMeta?.srcSet}
            sizes={coverMeta?.srcSet ? '(max-width: 767px) 100vw, 560px' : undefined}
            width={coverMeta?.width}
            height={coverMeta?.height}
            alt={post.imageAlt || post.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}

      {/* Date · reading time — uppercase utility label */}
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-medium text-ink/60 mb-3">
        <span>{formattedDate}</span>
        <span>·</span>
        <span>{`${post.readingTime} min read`}</span>
      </div>

      {/* Title */}
      <h3
        className="font-display font-medium text-ink text-[22px] md:text-[26px] mb-3 group-hover:text-primary transition-colors"
        style={{ lineHeight: 1.2, letterSpacing: '-0.015em' }}
      >
        {post.title}
      </h3>

      {/* Excerpt */}
      <p
        className="text-[15px] md:text-[16px] text-ink/70 mb-4 line-clamp-2"
        style={{ lineHeight: 1.55 }}
      >
        {post.excerpt}
      </p>

      {/* Category pills */}
      <div className="flex flex-wrap gap-2">
        {post.categories.map((cat) => (
          <span
            key={cat}
            className="inline-block text-[10px] uppercase tracking-[0.18em] font-medium text-primary border border-primary/25 rounded-full px-3 py-1"
          >
            {cat}
          </span>
        ))}
      </div>
    </a>
  );
};

export default BlogCard;
